import * as CoreFns from './CoreFns';

export function getItemType(objPath){
  if (objPath.length === 4){
    return 'PANEL';
  }else if (objPath.length === 2){
    return objPath[0];
  }else if (CoreFns.isAlert(objPath)){
    return 'ALERT';
  }else if (objPath.length === 3 && objPath[2] === 'nv'){
    return 'navBar';
  }else if (objPath.length === 1 && objPath[0] === 'fo'){
    return 'FOOTER';
  }else{
    return 'item';
  }

}

export function itemN(thisItem, itemEdited){
  var editElementName = 'Element';
  if (thisItem){
    if (itemEdited.t === 'page'){
      if (itemEdited.path[0] === 'fe'){
        editElementName = 'Page';
      }else{
        editElementName = 'Pop-Up';
      }
    }else if (itemEdited.t === 'screen'){
      if (itemEdited.path[0] === 'fo'){
        editElementName = 'Footer';
      }else{
        editElementName = 'Panel';
      }
    }else if (itemEdited.t === 'asset'){
      editElementName = 'Rich Text';
    }else if (itemEdited.t === 'alert'){
      editElementName = 'Banner';
    }else if (itemEdited.t === 'item'){
      editElementName = CoreFns.getElementInfo(thisItem.t).t;
    }
  }  
  return editElementName;
}

export function fullTitle(itemEdited, currentList, pathDown, thisFE){
  var editorBarTitle = '';
    if (itemEdited.t === 'screen' || itemEdited.t === 'item' || itemEdited.t === 'alert'){
      editorBarTitle = getItemTitle(currentList, pathDown, itemEdited.t);
    }else if (itemEdited.t === 'asset'){
      var tt = CoreFns.goDownPath(currentList, pathDown.concat(['_na']));
      editorBarTitle = 'Rich Text';
      if (tt){
        editorBarTitle += ' ' + tt;
      }
    }else if (itemEdited.t === 'navBar'){
      editorBarTitle = 'Navigation Bar'
    }else if (itemEdited.t === 'page'){
      var head;
      if (pathDown[0] === 'fe'){
        head = 'Page';
      }else {
        head = 'Pop-Up'
      }
      editorBarTitle = head + ' ' + thisFE.n;
    }  
    return editorBarTitle;
}
//
export function getItemTitle(currentList, objPath, itemType){
  var thisItem;
  var baseTitle;

  if (itemType === 'screen' && objPath.length === 1 && objPath[0] === 'fo'){
    return 'Footer';
  }  
  
  try{
    thisItem = CoreFns.goDownPath(currentList, objPath);
  }catch{
    if (itemType === 'item'){
      baseTitle = 'Item';
    }else if (itemType === 'screen'){
      baseTitle = 'Panel';
    }else if (itemType === 'alert'){
      baseTitle = 'Banner';
    }else if (itemType === 'asset'){
      baseTitle = 'Rich Text';
    }
    return 'Invalid ' + baseTitle;
  }
  if (itemType === 'item'){
    if (thisItem){
      baseTitle = getBaseTitle(thisItem);
    }else{
      baseTitle = 'Item';
    }
  }else if (itemType === 'screen'){
    baseTitle = 'Panel';
  }else if (itemType === 'alert'){
    baseTitle = 'Banner';
  }else if (itemType === 'asset'){
    baseTitle = 'Rich Text';
  }
  if (thisItem){
    if (thisItem._na){
      return baseTitle + ' ' + thisItem._na;
    }else{
      return 'Unnamed ' + baseTitle;
    }
  }else{
    return 'Invalid ' + baseTitle;
  }
}


export function getBaseTitle(thisItem){
    var thisType = thisItem.t;

    if (thisType === 'HR'){
      return 'Line Break';
    }else if (thisType === 'LINECHART'){
      return 'Line Chart';
    }else if (thisType === 'BARCHART'){
      return 'Bar Chart';
    }else if (thisType === 'PIECHART'){
      return 'Pie Chart';
    }else{
      var elementInfo = CoreFns.getElementInfo(thisType);
      return elementInfo.t;
    }      

}